import React, { useEffect, useRef, useState } from 'react';
import Quagga from 'quagga';
import { Modal, Button } from 'react-bootstrap';
import Scanner from '../../../components/Scanner';

const BarcodeScannerModal = ({
  setCode,
  code,
  clearFields
}) => {

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    if (code) {
      setShow(false)
    }
  }, [code]);

  return (
    <>
      <Button variant="primary m-2" onClick={() => {
        clearFields();
        handleShow();
      }}>
        LEITOR
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Leitor de Código de Barras</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Scanner code={code} setCode={setCode}></Scanner>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BarcodeScannerModal;
